import * as apiSW from 'api/ingredientCategory/GetIngredientCategoryStartingWithV1';
import * as apiPostSearch from 'api/ingredientCategory/PostIngredientCategorySearchV1';
import IngredientCategory from 'classes/StandingData/IngredientCategory/Search/IngredientCategory';
import { ISelectItem } from 'interfaces/ISelectItem';

export default class BaseIngredientCategoryList {
	public all: IngredientCategory[] = [];
	public filtered: ISelectItem[] = [];
	public totalCount: number = 0;

	public async search(searchTerm: string, showOnlyDeleted: boolean): Promise<void> {
		const baseIngredientCategories = await apiSW.callApi(searchTerm, showOnlyDeleted);
		baseIngredientCategories.hasValue() && this.mapFromApiSW(baseIngredientCategories.get());
	}

	public async callApi(input: apiPostSearch.Request) {
		return await apiPostSearch.callApi(input);
	}

	public mapFromApi(input: apiPostSearch.ResponseData): void {
		this.totalCount = input.totalCount;
		this.all = [];
		for (const i of input.data) {
			const ingredientCategory: IngredientCategory = new IngredientCategory(i);
			this.all.push(ingredientCategory);
		}
	}

	public mapFromApiSW(input: apiSW.ResponseIngredientCategory[]): void {
		this.filtered = [];
		for (const i of input) {
			this.filtered.push({
				id: i.id,
				name: i.description,
			});
		}
	}
}
